import React, { useEffect, useState } from 'react';
import Input from '../../../../FlyfishComponents/Input';
import styled from 'styled-components';
import {
	loadStateSession,
	saveStateSession,
} from '../../../../FlyfishComponents/flyfishutils/utils';
import { Checkbox, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import AutoComplete from '../../../../FlyfishComponents/AutoComplete';
import Button from '../../../../FlyfishComponents/Button';
import useScreenSize from '../../../../Hooks/DeviceScreenSize/index';
const Form = styled.div`
	width: 100%;
	margin-top: 28px;
	grid-template-columns: auto auto;
	display: ${(props) => (props.screenSize < 800 ? 'flex' : 'grid')};
	grid-gap: 28px 40px;
	flex-direction: column;
	gap: 28px;

	& > div {
		& > p {
			color: white;
			margin-bottom: 6px !important;
			margin-top: 24px !important;
			font-weight: 600;
			&.ff-chatbot-caption {
				margin: 0 !important;
				margin-bottom: 6px !important;
				font-weight: normal;
				color: white;
			}
		}
		& > .MuiFormGroup-root {
			label {
				& > .MuiTypography-root {
					line-height: unset !important;
				}
				path {
					fill: currentColor !important;
				}
			}
		}
		& > .ff-checkbox {
			margin-bottom: 16px;
			& > label {
				gap: 8px;
				& > .check {
					& path:last-child {
						fill: white;
					}
					&.checked {
						& path:last-child {
							fill: white;
						}
					}
				}
				& > .label {
					& > p {
						margin: 0 !important;
					}
				}
			}
		}
		& > .MuiFormGroup-root {
			margin-bottom: 16px;
			margin-left: 2px;
			gap: 16px;
			& > label {
				& > .MuiTypography-root {
					& > p {
						margin: 0 !important;
						color: white;
					}
				}
				& > span.MuiButtonBase-root {
					padding: 0px 9px !important;
					& path {
						fill: white;
					}
					&.Mui-checked {
						& path {
							fill: white;
						}
					}
				}
			}
		}
		& > div > .MuiFormControl-root {
			padding: 0 !important;
			& input,
			& textarea {
				font-size: 14px !important;
				color: var(--black-60);
			}

			& .MuiInputBase-root {
				& > input,
				& > textarea {
					color: ${(props) =>
						props.shouldDisableActions ? '#bfbfbf !important' : 'na'};
					-webkit-text-fill-color: ${(props) =>
						props.shouldDisableActions ? '#bfbfbf !important' : 'na'};
				}
				padding: 8px 12px !important;
				& input {
					text-transform: capitalize;
				}

				&.Mui-error {
					.MuiOutlinedInput-notchedOutline {
						border-color: var(--colorScale-1);
					}
				}
				border-radius: 12px;
				&:not(.Mui-focused, .Mui-disabled, .Mui-error):hover {
					.MuiOutlinedInput-notchedOutline {
						border-color: #757575;
					}
				}
				background-color: white;
				&:not(.Mui-disabled, .Mui-error).Mui-focused {
					.MuiOutlinedInput-notchedOutline {
						border-color: #0d0d0d;
					}
				}
			}
			& .MuiFormHelperText-root.Mui-error {
				color: red;
			}
		}

		& > div {
			& > .MuiAutocomplete-root {
				& .MuiFormControl-root {
					padding: 0 !important;
				}
				& .MuiInputBase-root {
					& > input,
					& > textarea {
						color: ${(props) =>
							props.shouldDisableActions ? '#bfbfbf !important' : 'na'};
						-webkit-text-fill-color: ${(props) =>
							props.shouldDisableActions ? '#bfbfbf !important' : 'na'};
					}
					background-color: white;
					padding: 8px !important;
					padding-left: 10px !important;
					& input {
						font-size: 14px;
					}
					&:not(.Mui-focused, .Mui-disabled, .Mui-error):hover {
						.MuiOutlinedInput-notchedOutline {
							border-color: #757575;
						}
					}
					&:not(.Mui-disabled, .Mui-error).Mui-focused {
						.MuiOutlinedInput-notchedOutline {
							border-color: var(--colorScale-1) !important;
						}
					}
				}
			}
		}
	}
	& > div {
		&.button-holder-forms {
			grid-column: span 2;
			&.positionChange {
				position: absolute;
				bottom: -60px;
				left: 50%;
				transform: translateX(-50%);
			}

			button {
				width: 156px !important;
			}
			&.squeezeButton {
				button {
					width: 135px !important;
				}
			}
		}
		& > .custom-button {
			max-width: 220px;
		}
		& > .custom-button:first-child {
			.MuiButton-root {
				&:not(.Mui-disabled):hover {
					&:after {
						background-color: var(--black-10);
						border-radius: 20px;
					}
				}
			}
			& > button {
				width: fit-content;
				padding: 9px 12px;
				border-radius: 20px;
				border: 1px solid #01478d;
				font-family: var(--fontFamily);
				font-size: 14px;
				font-style: normal;
				font-weight: 400;
				line-height: 11.951px;
				cursor: pointer;
				width: 164px;
				height: 37px;
				background-color: white !important;

				& > .custom-button-body {
					color: #161616 !important;
					font-size: 12px;
					font-style: normal;
					font-weight: 400;
					line-height: normal;
					font-family: var(--fontFamily);
				}
			}
		}
		& > .custom-button:last-child {
			.MuiButton-root {
				&:not(.Mui-disabled):hover {
					&:after {
						background-color: var(--black-10);
						border-radius: 20px;
					}
				}
			}
			& > button {
				width: fit-content;
				padding: 8px 12px;
				border-radius: 20px;
				color: #fff;
				font-family: var(--fontFamily);
				font-size: 14px;
				font-style: normal;
				font-weight: 400;
				line-height: 11.951px;
				cursor: pointer;
				width: 164px;
				height: 37px;
				background-color: #0174e7 !important;

				& > .custom-button-body {
					color: #fff;
					font-size: 12px;
					font-style: normal;
					font-weight: 400;
					line-height: normal;
					font-family: var(--fontFamily);
				}
				& > .button-loader {
					display: flex;
					color: white !important;
				}
			}
		}
	}
`;
export default function Forms({
	form,
	submitChat,
	submitLoader,
	setSubmitLoader,
	allMessages,
	currentIndex,
	formIsActive,
	isLastMessage,
}) {
	const screenSize = useScreenSize();
	const [workflowValues, setWorkflowValues] = useState(
		form && form.map(() => '') // Initialize state for each form input
	);
	const [showPassword, setShowPassword] = useState(
		form && form.map(() => '') // Initialize state for each form input
	);

	const shouldDisableActions = !isLastMessage;
	const colorMode = loadStateSession('colorMode');
	const validationCheck = () => {
		let validation = form.map((list, index) => {
			if (list.enabled.toLowerCase() === 'true') {
				let validator = new RegExp(list.validation, 'iu');

				if (list.validationType.toLowerCase() === 'multiple select') {
					if (workflowValues[index]) {
						let check = workflowValues[index].filter((v) => v.length > 0);
						return check[0] === undefined ? true : false;
					}
				} else if (list.validationType.toLowerCase() === 'drop down') {
					if (workflowValues[index] && workflowValues[index].value) {
						return false;
					}
				} else if (list.name.toLowerCase() === 'your message') {
					return { validate: 'yourMessage', v: false };
				}

				return workflowValues[index] && !validator.test(workflowValues[index]);
			}
		});

		let filterTrue = validation.filter((value) => value === true)[0];
		let filterEmpty = validation.filter(
			(value) => value === '' && value.validate !== 'yourMessage'
		);

		let buttonDisable = false;
		if (filterTrue === undefined && filterEmpty.length === 0) {
			buttonDisable = false;
		} else {
			buttonDisable = true;
		}
		return buttonDisable;
	};
	const errTextAndIconColor = () => {
		return 'red';
	};
	const InfoIcon = () => {
		return (
			<svg
				style={{ position: 'relative', bottom: '1px' }}
				xmlns='http://www.w3.org/2000/svg'
				width='13.909'
				height='13.909'
				viewBox='0 0 13.909 13.909'
			>
				<path
					d='M8.259 11.041H9.65v1.391H8.259zm0-5.564H9.65V9.65H8.259zM8.947 2a6.954 6.954 0 1 0 6.961 6.954A6.951 6.951 0 0 0 8.947 2zm.007 12.518a5.564 5.564 0 1 1 5.564-5.564 5.562 5.562 0 0 1-5.564 5.564z'
					transform='translate(-2 -2)'
					fill={'red'}
				/>
			</svg>
		);
	};

	const handleMultipleSelectChange = (index, option) => {
		let updatedValues = [...workflowValues];
		const selectedOptions = updatedValues[index] || [];

		if (selectedOptions.includes(option)) {
			updatedValues[index] = selectedOptions.filter((val) => val !== option);
		} else {
			updatedValues[index] = [...selectedOptions, option];
		}

		setWorkflowValues(updatedValues);
	};

	const handleMultipleChoiceChange = (index, value) => {
		let updatedValues = [...workflowValues];
		updatedValues[index] = value;
		setWorkflowValues(updatedValues);
	};

	return (
		<div className='ff-form'>
			<Form
				colorMode={colorMode}
				screenSize={screenSize}
				shouldDisableActions={shouldDisableActions}
			>
				{form.map((list, index) => {
					if (list.enabled.toLowerCase() === 'true') {
						let validator = new RegExp(list.validation, 'i');
						return (
							<div
								key={index}
								style={{
									gridColumn: `${
										list.name === 'Your Message' ||
										list.validationType.toLowerCase().indexOf('multiple') > -1
											? 'span 2'
											: ''
									}`,
								}}
							>
								{list.name ? (
									<>
										{list.validationType.toLowerCase() === 'text' ? (
											<Input
												className={`${
													workflowValues[index] ? 'removeOpacity' : ''
												}`}
												multiline={list.name === 'Your Message' ? true : false}
												initialRows={3}
												placeholder={list.name}
												autoFocus={index === 0}
												disabled={shouldDisableActions}
												error={
													workflowValues[index] &&
													!validator.test(workflowValues[index])
												}
												errorText={
													<div
														style={{
															display: 'flex',
															alignItems: 'center',
															gap: '5px',
														}}
													>
														{InfoIcon()}
														<p style={{ margin: 0, color: 'red' }}>
															Please provide valid text
														</p>
													</div>
												}
												fullWidth
												value={workflowValues[index]}
												onChange={(e) => {
													let updatedValues = [...workflowValues];
													updatedValues[index] = e.target.value;
													setWorkflowValues(updatedValues);
												}}
												limit={255}
											/>
										) : null}
										{list.validationType.toLowerCase() === 'email' ? (
											<Input
												placeholder={list.name}
												type='email'
												autoFocus={index === 0}
												disabled={shouldDisableActions}
												error={
													workflowValues[index] &&
													!validator.test(workflowValues[index])
												}
												errorText={
													<div
														style={{
															display: 'flex',
															alignItems: 'center',
															gap: '5px',
														}}
													>
														{InfoIcon()}
														<p style={{ margin: 0, color: 'red' }}>
															Please provide valid email
														</p>
													</div>
												}
												fullWidth
												value={workflowValues[index]}
												onChange={(e) => {
													let updatedValues = [...workflowValues];
													updatedValues[index] = e.target.value;
													setWorkflowValues(updatedValues);
												}}
												limit={255}
											/>
										) : null}
										{list.validationType.toLowerCase() === 'date' ? (
											<Input
												autoFocus={index == 0 ? true : false}
												disabled={shouldDisableActions}
												error={
													workflowValues[index] &&
													!validator.test(workflowValues[index])
												}
												errorText={
													<div
														style={{
															display: 'flex',
															alignItems: 'center',
															gap: '5px',
														}}
													>
														{InfoIcon()}
														<p
															style={{
																margin: 0,
																color: errTextAndIconColor(),
															}}
														>
															Please provide a valid date
														</p>
													</div>
												}
												fullWidth
												placeholder='DD-MM-YYYY'
												type='date'
												value={workflowValues[index]}
												onChange={(e) => {
													let v = [...workflowValues];

													v[index] = e.target.value;

													setWorkflowValues(v);
												}}
											/>
										) : null}
										{list.validationType.toLowerCase() === 'time' ? (
											<Input
												placeholder={list.name}
												autoFocus={index == 0 ? true : false}
												disabled={shouldDisableActions}
												error={
													workflowValues[index] &&
													!validator.test(workflowValues[index])
												}
												errorText={
													<div
														style={{
															display: 'flex',
															alignItems: 'center',
															gap: '5px',
														}}
													>
														{InfoIcon()}
														<p
															style={{
																margin: 0,
																color: errTextAndIconColor(),
															}}
														>
															Please provide a valid time
														</p>
													</div>
												}
												fullWidth
												type='time'
												value={workflowValues[index]}
												onChange={(e) => {
													let v = [...workflowValues];
													v[index] = e.target.value;

													setWorkflowValues(v);
												}}
											/>
										) : null}
										{list.validationType.toLowerCase() === 'number' ? (
											<Input
												placeholder={list.name}
												autoFocus={index == 0 ? true : false}
												disabled={shouldDisableActions}
												error={
													workflowValues[index] &&
													!validator.test(workflowValues[index])
												}
												type={showPassword[index] ? 'text' : 'password'}
												errorText={
													<div
														style={{
															display: 'flex',
															alignItems: 'center',
															gap: '5px',
														}}
													>
														{InfoIcon()}
														<p
															style={{
																margin: 0,
																color: errTextAndIconColor(),
															}}
														>
															Please provide a valid phone number
														</p>
													</div>
												}
												fullWidth
												value={workflowValues[index]}
												onChange={(e) => {
													let v = [...workflowValues];
													let mobileNumber = e.target.value;
													v[index] = mobileNumber;
													setWorkflowValues(v);
												}}
												limit={15}
												// endIcon={
												// 	<svg
												// 		onClick={() => {
												// 			let v = [...showPassword];

												// 			v[index] = !v[index];
												// 			setShowPassword(v);
												// 		}}
												// 		xmlns='http://www.w3.org/2000/svg'
												// 		viewBox='0 0 24 24'
												// 		fill='none'
												// 		stroke='currentColor'
												// 		stroke-width='2'
												// 		stroke-linecap='round'
												// 		stroke-linejoin='round'
												// 		className='feather feather-eye'
												// 	>
												// 		<path d='M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z'></path>
												// 		<circle cx='12' cy='12' r='3'></circle>
												// 	</svg>
												// }
											/>
										) : null}
										{list.validationType.toLowerCase() === 'multiple select' ? (
											<>
												{list.optionList.map((val, i) => (
													<FormControlLabel
														key={i}
														control={
															<Checkbox
																checked={
																	workflowValues[index]?.includes(val) || false
																}
																onChange={() =>
																	handleMultipleSelectChange(index, val)
																}
																disabled={shouldDisableActions}
															/>
														}
														label={val}
													/>
												))}
											</>
										) : null}
										{list.validationType.toLowerCase() === 'multiple choice' ? (
											<RadioGroup
												className='multiple-choice'
												aria-labelledby={`choice-${index}-label`}
												value={workflowValues[index]}
												onChange={(e) =>
													handleMultipleChoiceChange(index, e.target.value)
												}
											>
												{list.optionList.map((val, i) => (
													<FormControlLabel
														key={i}
														value={val}
														control={<Radio disabled={shouldDisableActions} />}
														label={val}
													/>
												))}
											</RadioGroup>
										) : null}
										{list.validationType.toLowerCase() === 'drop down' ? (
											<>
												<AutoComplete
													disabled={shouldDisableActions}
													placeholder={list.name}
													multiple={false}
													classNameOndropLI='workflowdrop'
													options={list.optionList.map((opt: any) => {
														return {
															label: opt,
															value: opt,
														};
													})}
													valueKey='value'
													labelKey='label'
													value={
														workflowValues[index] === '' ||
														workflowValues[index] === null
															? null
															: workflowValues[index]
													}
													onChange={(val) => {
														let v = [...workflowValues];
														v[index] = val;
														setWorkflowValues(v);
													}}
												/>
											</>
										) : null}
									</>
								) : null}
							</div>
						);
					}
				})}
				<div
					style={{
						display: !formIsActive ? 'none' : 'flex',
						gap: '15px',
						justifyContent: screenSize < 800 ? 'center' : 'flex-end',
						position: 'fixed',
						bottom: '20px',
						zIndex: 1,
						left: '50%',
						transform: 'translateX(-50%)',
					}}
					className={`button-holder-forms ${
						screenSize < 325 ? 'squeezeButton' : ''
					} ${screenSize < 500 ? 'positionChange' : ''}`}
				>
					<Button
						size={'large'}
						fullWidth
						disabled={shouldDisableActions}
						onClick={() => {
							submitChat('Cancel');
						}}
					>
						Cancel
					</Button>
					<Button
						size='large'
						loading={submitLoader}
						fullWidth
						disabled={
							shouldDisableActions ? shouldDisableActions : validationCheck()
						}
						onClick={() => {
							const formObject = {};
							form.forEach((item, i) => {
								if (item.enabled.toLowerCase() === 'true') {
									if (item.type.name.trim().toLowerCase() === 'drop down') {
										formObject[item.name] = workflowValues[i].value;
									} else if (
										item.type.name.trim().toLowerCase() === 'multiple select'
									) {
										formObject[item.name] = workflowValues[i].toString();
									} else {
										formObject[item.name] = workflowValues[i];
									}
								}
							});
							let data = { form: formObject };
							setSubmitLoader(true);
							submitChat('Submit', data);
						}}
					>
						Submit
					</Button>
				</div>
			</Form>
		</div>
	);
}
